
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import "./index.css";

// Add debugging information
console.info("Main.jsx is executing - Application starting...");

// Add comprehensive performance monitoring
if (process.env.NODE_ENV !== 'production') {
  // Monitor long tasks
  const observer = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      console.warn(`Long task detected: ${entry.duration}ms`, entry);
    });
  });
  
  observer.observe({ entryTypes: ['longtask'] });
  
  // Monitor layout shifts
  const clsObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      if (entry.value > 0.1) {
        console.warn(`Large layout shift detected:`, entry);
      }
    });
  });
  
  clsObserver.observe({ type: 'layout-shift', buffered: true });
  
  // Monitor LCP (Largest Contentful Paint)
  const lcpObserver = new PerformanceObserver((list) => {
    const entries = list.getEntries();
    const lastEntry = entries[entries.length - 1];
    console.info(`LCP: ${lastEntry.startTime}`, lastEntry);
  });
  
  lcpObserver.observe({ type: 'largest-contentful-paint', buffered: true });
  
  // Monitor FID (First Input Delay)
  const fidObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      console.info(`FID: ${entry.processingStart - entry.startTime}ms`, entry);
    });
  });
  
  fidObserver.observe({ type: 'first-input', buffered: true });
  
  // Monitor resource loading
  const resourceObserver = new PerformanceObserver((list) => {
    list.getEntries().forEach((entry) => {
      if (entry.duration > 500) {
        console.warn(`Slow resource load: ${entry.name} (${entry.duration}ms)`, entry);
      }
    });
  });
  
  resourceObserver.observe({ entryTypes: ['resource'] });
}

try {
  console.info("Attempting to render React application...");
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(<App />);
  console.info("React application rendered successfully");
} catch (error) {
  console.error("Error rendering React application:", error);
  // Display a fallback UI for users
  document.getElementById("root").innerHTML = `
    <div style="padding: 20px; text-align: center;">
      <h2>Something went wrong</h2>
      <p>The application failed to load. Please try refreshing the page.</p>
      <p>Error details: ${error.message}</p>
    </div>
  `;
}
